<app-header *ngIf="!carregandoComponentes"></app-header>
<div class="lovers">
  <router-outlet></router-outlet>
</div>
<app-footer *ngIf="!carregandoComponentes"></app-footer>